import { setValue } from "../helpers/reducer-utilities";
export function matchmaking(state = {}, action) {
  switch (action.type) {
    case "SET_MATCHMAKING_VALUE":
      return setValue(state, action.payload.changes);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux-reducers/matchmaking-reducer.js